var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAkten = function SvgIconAkten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 160
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "685-a",
    x1: 0.5,
    y1: 0.085,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c52cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a1343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "685-c",
    x1: 0.5,
    y1: 0.083,
    x2: 0.5,
    y2: 0.917,
    xlinkHref: "#685-a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "685-d",
    x1: 0.5,
    y1: 0.087,
    x2: 0.5,
    y2: 0.92,
    xlinkHref: "#685-a"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "685-b",
    x: 26.096,
    y: 32,
    width: 147.904,
    height: 102.832,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#685-b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.51 23.4a8.115 8.115 0 0 0-2.022-3.37 10.928 10.928 0 0 0-3.466-2.311 11.9 11.9 0 0 0-3.755-.867 10.171 10.171 0 0 0-10.11-10.11h-54.5L48.916 0H17.622A10.109 10.109 0 0 0 7.511 10.11v16.37c-.289.1-.674.1-.963.193l-.867.289a8.25 8.25 0 0 0-3.37 2.215A8.671 8.671 0 0 0 .386 32.45a7.382 7.382 0 0 0-.192 3.85l7.414 40.925a7.56 7.56 0 0 0 1.348 2.985 10.449 10.449 0 0 0 2.6 2.407 14.326 14.326 0 0 0 3.466 1.637 13.506 13.506 0 0 0 3.948.578h90.512a13.506 13.506 0 0 0 3.948-.578 14.326 14.326 0 0 0 3.466-1.637 8.921 8.921 0 0 0 2.6-2.407 7 7 0 0 0 1.348-2.985l9.051-49.782a11.143 11.143 0 0 0-.385-4.043Z",
    transform: "translate(35.07 38.002)",
    style: {
      fill: "url(#685-a)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.51 23.636a8.115 8.115 0 0 0-2.022-3.37 10.928 10.928 0 0 0-3.466-2.311 11.49 11.49 0 0 0-4.526-.867h-2.022v-1.059a2.691 2.691 0 0 0-2.7-2.7H56.041L49.108 6.4H17.622A9.967 9.967 0 0 0 7.511 16.414v10.3a5.809 5.809 0 0 0-1.829.578 8.25 8.25 0 0 0-3.37 2.215 8.671 8.671 0 0 0-1.926 3.277 7.382 7.382 0 0 0-.193 3.852l7.415 40.923a7.559 7.559 0 0 0 1.348 2.985 10.449 10.449 0 0 0 2.6 2.407 14.326 14.326 0 0 0 3.466 1.637 13.506 13.506 0 0 0 3.948.578h90.512a13.505 13.505 0 0 0 3.948-.578 14.326 14.326 0 0 0 3.466-1.637 8.921 8.921 0 0 0 2.6-2.407 7 7 0 0 0 1.348-2.985l9.051-49.782a11.462 11.462 0 0 0-.385-4.141Z",
    transform: "translate(35.07 37.763)",
    style: {
      fill: "url(#685-c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.555 66.729V16.851a10.109 10.109 0 0 0-10.11-10.11h-54.5L49.2 0H17.91A10.109 10.109 0 0 0 7.8 10.11v56.523h112.755Z",
    transform: "translate(34.779 38)",
    style: {
      fill: "#0a1343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.382 65.112H20.8a2.691 2.691 0 0 1-2.7-2.7V16.2a2.691 2.691 0 0 1 2.7-2.7h88.586a2.691 2.691 0 0 1 2.7 2.7v46.119a2.656 2.656 0 0 1-2.704 2.793Z",
    transform: "translate(34.4 37.499)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.629 20.4a3.461 3.461 0 0 1 1.059.193 4.522 4.522 0 0 1 .867.578 3.9 3.9 0 0 1 .481.867 3.61 3.61 0 0 1 .1 1.059l-5.3 41.309a3.06 3.06 0 0 1-.289.867 2.249 2.249 0 0 1-.674.674 3.9 3.9 0 0 1-.867.481 3.461 3.461 0 0 1-1.059.193H20.785a4.1 4.1 0 0 1-1.059-.193 3.9 3.9 0 0 1-.867-.481 2.25 2.25 0 0 1-.674-.674 1.553 1.553 0 0 1-.285-.873l-5.3-41.3a3.61 3.61 0 0 1 .1-1.059 3.9 3.9 0 0 1 .481-.867 1.4 1.4 0 0 1 .867-.578A3.462 3.462 0 0 1 15.1 20.4Z",
    transform: "translate(34.601 37.243)",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.492 17.4a11.49 11.49 0 0 1 4.526.867 10.928 10.928 0 0 1 3.466 2.311 8.178 8.178 0 0 1 2.215 7.414l-9.052 49.778a7.559 7.559 0 0 1-1.348 2.985 10.448 10.448 0 0 1-2.6 2.407 14.326 14.326 0 0 1-3.466 1.637 13.506 13.506 0 0 1-3.948.578H18.774a13.506 13.506 0 0 1-3.948-.578 14.326 14.326 0 0 1-3.466-1.637 8.921 8.921 0 0 1-2.6-2.407 7 7 0 0 1-1.348-2.985L.094 36.943a7.382 7.382 0 0 1 .193-3.852 8.671 8.671 0 0 1 1.926-3.274A8.25 8.25 0 0 1 5.582 27.6a12.947 12.947 0 0 1 4.429-.867h67.98L91.568 17.3h27.924Z",
    transform: "translate(35.074 37.358)",
    style: {
      fill: "url(#685-d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h200v160H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(133 14.537)",
    style: {
      fill: "#f7f7f9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.062 19.599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.6 30.635 9.987 9.987L45.21 20l-5.271 5.271",
    transform: "translate(-2.486 -2.892)",
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.465,
    cy: 27.465,
    r: 27.465,
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  })));
};
export default SvgIconAkten;